import axios from 'axios'
import React, { useContext, useState,useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import authenticate from '../../utils/Authenticate';
import UserContext from '../../contexts/UserContext';
import displayError from '../../utils/ErrorHandler';

const AddZoneSupplier = () => {
  const {user,setUser} = useContext(UserContext);
  const navigate = useNavigate();

    const [formData,setFormData] = useState({
        name:'',
        company:'',
        address:'',
        username:'',
        password:''
      })
      const [notification, setNotification] = useState({ message: '', type: '' });
      const [zones,setZones] = useState([])
      const [selectedOptions, setSelectedOptions] = useState([]);
    
      // Load options from the backend API
      const loadOptions = async (inputValue, callback) => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_URI}/api/findItemsForZoneSupplier`, {
            params: { q: inputValue }
          });
          const options = response.data.map(record => ({
            value: record._id,
            label: record.name
          }));
          callback(options);
        } catch (error) {
          console.error('Error loading options:', error);
        }
      };
    
      const handleItemChange = (selected) => {
        setSelectedOptions(selected);
      };
    
      const handlechange = (e) => {
        if(e.target.name==="zones"){
          if(zones.includes(e.target.value)){
            setZones((prevItems) => prevItems.filter(item => item !== e.target.value));
            if(zones.length===1){
              setZones([])
            }
          }else{
            setZones([...zones,e.target.value])
          }
        }else{
          setFormData({
            ...formData,
            [e.target.name]:e.target.value
          })
        }
        
      }
    
      const submitData = (e) => {
        e.preventDefault();
        const finalObject = {
          supplier:{
            username:formData.username,
            password:formData.password,
            name:formData.name,
            company:formData.company,
            address:formData.address,
            role:'Supplier',
            items:selectedOptions,
            internalRole: 'Zone'
          }
        }
    
        axios.post(`${process.env.REACT_APP_API_URI}/api/zones/createSupplier`,finalObject,{withCredentials:true})
        .then((response) => {
          console.log(response)
          setNotification({ message: response.data.message, type: 'success' });
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        setFormData({
          name: '',
          company: '',
          address: '',
          username: '',
          password: '',
        });
        setSelectedOptions([]);
        })
        .catch((err) => {
          const errorMessage = displayError(err,navigate,setUser);
          console.log(errorMessage);
            if(errorMessage){
              setNotification({ message: errorMessage, type: 'error' });
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
              });
            }
          })
      }

      useEffect( () => {
        async function startup(){
          if(!user){
            await authenticate(setUser,navigate);
          }
        }
        startup();
      },[user])
    
            
      const design = (

        <>
        
          <div className="bg-lime-800 flex items-center justify-between w-full p-4 text-white fixed z-10">
            <h4 className="text-lg md:text-xl font-semibold text-center flex-grow">Add Zone Supplier</h4>
          </div>
          <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-4 lg:px-8 pt-[75px]">
          {notification.message && (
              <div
                className={`mb-4 p-4 ${notification.type === 'success' ? 'bg-green-200 border-green-600 text-green-600' : 'bg-red-200 border-red-600 text-red-600'}`}
              >
                {notification.message}'
              </div>
            )}
            <form className="space-y-6" onSubmit={submitData} >
                <div>
                  <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">
                    Supplier Name
                  </label>
                  <div className="mt-2">
                    <input
                      id="name"
                      name="name"
                      type="text"
                      placeholder='Supplier Name'
                      autoComplete="name"
                      value={formData.name}
                      onChange={handlechange}
                      required
                      className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
    
                <div>
                  <label htmlFor="company" className="block text-sm font-medium leading-6 text-gray-900">
                    Company Name
                  </label>
                  <div className="mt-2">
                    <input
                      id="company"
                      name="company"
                      type="text"
                      placeholder='Supplier company'
                      autoComplete="company"
                      value={formData.company}
                      onChange={handlechange}
                      required
                      className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
    
                <div>
                  <label htmlFor="desc" className="block text-sm font-medium leading-6 text-gray-900">
                    Address
                  </label>
                  <div className="mt-2">
                    <input
                      id="address"
                      name="address"
                      type="text"
                      placeholder='Supplier address'
                      autoComplete="address"
                      value={formData.address}
                      onChange={handlechange}
                      required
                      className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
    
                {/* <label htmlFor="multi-select">Choose options:</label>
                <select id="multi-select" className="block w-full rounded-md border-0 py-3 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" name='zones' value={zones} multiple onChange={handlechange}>
                  <option className='py-2' value="option1">Zone 1</option>
                  <option className='py-2' value="option2">Zone 2</option>
                  <option className='py-2' value="option3">Zone 3</option>
                  <option className='py-2' value="option4">Zone 4</option>
                </select> */}
                <div>
                  <label htmlFor="multi-select" className="block text-sm font-medium leading-6 text-gray-900">Select Items that Supplier deals in:</label>
                  <AsyncSelect
                    id="multi-select"
                    isMulti
                    loadOptions={loadOptions}
                    onChange={handleItemChange}
                    value={selectedOptions}
                    placeholder="Search and select options..."
                    className='rounded-full'
                  />
                </div>
    
                <label className="block text-md font-semibold leading-6 text-gray-900">
                  Supplier Credentials
                </label>
                <div className="flex min-h-full flex-1 flex-col justify-center px-1 py-0 lg:px-8">
                  <div>
                    <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900">
                      Username
                    </label>
                    <div className="mt-1">
                      <input
                        id="username"
                        name="username"
                        type="username"
                        placeholder='Username'
                        autoComplete="username"
                        value={formData.username}
                        onChange={handlechange}
                        required
                        className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      />
                    </div>
                  </div>
    
                  <div className='mt-2'>
                    <div className="flex items-center justify-between">
                      <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-700">
                        Password
                      </label>
                    </div>
                    <div className="mt-2">
                      <input
                        id="password"
                        name="password"
                        type="password"
                        placeholder='Password'
                        autoComplete="current-password"
                        value={formData.password}
                        onChange={handlechange}
                        required
                        className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      />
                    </div>
                  </div>
                </div>
    
                <div>
                  <button
                    type="submit"
                    onClick={submitData}
                    className="flex w-full justify-center rounded-full text-white bg-fmb px-3 py-3 text-sm font-semibold leading-6 shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    SUBMIT
                  </button>
                </div>
              </form>
            </div>
        </>
      )
      return design;
}

export default AddZoneSupplier